import { Icon } from "@mui/material";

const content = {
  hero: [
  { image: "/images/labels.jpg", text: "High-Quality Labels", subtext: "Durable, customized, and industry-standard" },
  { image: "/images/signage.jpg", text: "Custom Signage", subtext: "Make your brand visible everywhere" },
  { image: "/images/printing.jpg", text: "Complete Printing Solutions", subtext: "From canvas to packaging, we print it all" }
],
  company: {
    name: "SLN Advertising & Printing",
    tagline: "Innovative, high-quality labeling & signage for industry",
    established: 2018,
    address: "#52, Gollahalli Tulaslipura Main Road, Anjanapura, Bengaluru, Karnataka 560108, India",
    email: "slnadverpri@gmail.com",
    phones: [
      "+91 80737 24809 (N NARASIMHA MURTHY)",
      "+91 89047 12909 (SAHANA YADAV)"
    ],
    logo: ""
  },
  mission: "Create high-quality, customized labeling solutions that empower businesses to showcase their brands effectively through outstanding design and reliable service.",
  vision: "Be the premier provider of innovative and sustainable labeling solutions, leading in quality, creativity, and environmental responsibility.",
  goals: [
    "Develop strategically astute, creatively brilliant communication to solve tough business challenges.",
    "Build brands by telling compelling, consistent stories across touchpoints.",
    "Prioritize meeting customer requirements with speed and precision."
  ],
  services: [
    { title: "Specialty Labels", description: "Custom specialty labels for industrial & retail use.", image: "" },
    { title: "Overlay Labels", description: "Durable overlay labels for controls and displays.", image: "" },
    { title: "Identification Labels", description: "Clear identification & asset tags.", image: "" },
    { title: "Caution Labels", description: "Safety and hazard labels.", image: "" }
  ],
  team: [
    { name: "N NARASIMHA MURTHY", title: "Proprietor", photo: "" },
    { name: "SAHANA YADAV", title: "Manager", photo: "" },
    { name: "SHILPA SHREE", title: "Operations", photo: "" },
    { name: "DEVRATH V", title: "Production", photo: "" },
    { name: "PAVITHRA", title: "Support", photo: "" }
  ],
  clients: [
    {"name": "TATA Electronics", logo: "" },
    {"name": "Mahindra Aero Structures Pvt. Ltd.", logo: "" },
    {"name": "Thraiking Industrial Controls", logo: "" },
    {"name": "Honda Motorcycle & Scooters Pvt. Ltd.", logo: "" },
    {"name": "Pegatron India Pvt. Ltd.", logo: "" },
    {"name": "Teknix Elevators Pvt. Ltd.", logo: "" }
  ],
  portfolio: [],
  social: { facebook: "", instagram: "", linkedin: "" }
};

if (typeof window !== 'undefined' && window.localStorage) {
  const saved = window.localStorage.getItem('sln_content_v1');
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      Object.assign(content, parsed);
    } catch (e) {
      console.warn('Failed parsing saved content', e);
    }
  }
}

export default content;
